import React, { useState } from 'react';
import { Box, FormGroup, TextField, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Button } from '@mui/material';

type Props = {
	id?: number;
	onValidate: (name: string, code: string) => void;
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
};

const PlanetCreationVersionModal: React.FC<Props> = ({ id, onValidate, isOpen, setIsOpen }) => {
	const [currentName, setCurrentName] = useState('');
	const [currentCode, setCurrentCode] = useState('');

	const isValid = () => currentName?.length === 0 || currentCode?.length === 0;

	return (
		<Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="md" fullWidth>
			<DialogTitle>{id ? 'Modifier la version' : 'Créer une nouvelle version'}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<Box margin="0.5rem 1rem">
						<FormGroup>
							<TextField label="Titre" name="versionName" value={currentName} title="Titre" required onChange={(e) => setCurrentName(e.target.value)} inputProps={{ maxLength: 50 }} />
							<br />
							<TextField label="Code" name="versionCode" value={currentCode} title="Code" required onChange={(e) => setCurrentCode(e.target.value)} inputProps={{ maxLength: 5, style: { textTransform: 'uppercase' } }} />
						</FormGroup>
					</Box>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setIsOpen(false)}>Annuler</Button>
				<Button onClick={() => onValidate(currentName, currentCode)} disabled={isValid()}>
					Valider
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PlanetCreationVersionModal;
